import f1 from './1.png';
import f2 from './2.png';
import f3 from './3.png';
import f4 from './4.png';

export default [f1, f2, f3, f4];